import { apiGet } from '../../framework/client';
import { ERROR_API_CALL_FAILED } from '../../../common/framework/constants';
import { InvoiceRowType } from '../../../common/application/model/enums/InvoiceRowType';
import { VatPercentage } from '../../../common/application/model/VatPercentage';

export async function getInvoiceRowTypeVatPercentage(
    invoiceRowType: InvoiceRowType,
    countryCode: string,
    salesInvoiceId: string,
    vehicleContractId?: string,
    startDate?: Date,
) {
    const queryParams = { countryCode, vehicleContractId, salesInvoiceId, startDate };
    const response = await apiGet(`/api/invoice-row-type-vat-percentage/${invoiceRowType}`, queryParams);
    if (response.status === 200) {
        return (await response.json()) as VatPercentage;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
}
